export default __webpack_public_path__ + "static/media/480_dummy2016-schneiderei01-de.ac3bfdaf.png";